import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../dataContext";
import { ROUTE_CONSTANTS } from "../../constants/routeConstants";
import { ReactComponent as Download } from "../../assets/ico_download.svg";

const { PAYMENT_REQUEST_DETAIL } = ROUTE_CONSTANTS;

const PaymentRequests = () => {
  const navigate = useNavigate();
  const { paymentRequests, getPaymentRequests, locallyHandledRequestIds } =
    useContext(DataContext);

  useEffect(() => {
    getPaymentRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Backend already filters to pending incoming RfPs; we only need to drop
  // anything the user optimistically declined locally.
  const visible = (paymentRequests || []).filter(
    (t) => !(locallyHandledRequestIds || []).includes(t.id)
  );

  return (
    <main className="page_with_nav">
      {visible.length === 0 ? (
        <div
          className="center_page_with_nav"
          style={{ flexDirection: "column", textAlign: "center" }}
        >
          <h3>You're all caught up</h3>
          <p style={{ marginTop: "8px", fontSize: "14px", color: "#666" }}>
            No pending payment requests.
          </p>
        </div>
      ) : (
        <ul style={{ padding: 0, margin: 0 }}>
          {visible.map((request) => (
            <li
              key={request.id}
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(PAYMENT_REQUEST_DETAIL.replace(":id", request.id))
              }
              data-cy="pending_payment_request_row"
            >
              <div style={{ display: "flex" }}>
                <div className="history_icon bg_sending_bg_secondary">
                  <Download className="fill_sending_bg_secondary stroke_sending_bg_primary" />
                </div>
                <div>
                  <div style={{ fontSize: "12px", fontWeight: 550 }}>
                    {request.sender_name || "Someone"} is requesting
                  </div>
                  <div style={{ fontSize: "10px", marginTop: "3px" }}>
                    Awaiting Your Payment
                  </div>
                  {request.note && (
                    <div
                      style={{
                        fontSize: "10px",
                        marginTop: "3px",
                        opacity: 0.7,
                      }}
                    >
                      "{request.note}"
                    </div>
                  )}
                </div>
              </div>
              <div className="amount">
                ${parseFloat(request.amount?.value).toFixed(2)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
};

export default PaymentRequests;
